import { render } from "./SnehaSparsham.vue?vue&type=template&id=d6fbcb0a"
import script from "./SnehaSparsham.vue?vue&type=script&lang=js"
export * from "./SnehaSparsham.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__